import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('dynamic-input-custom-options', {
  template: require('./template.html'),
  name: 'dynamic-input-custom-options',
  computed: {
    ...mapGetters(['currentSite', 'activeSiteType']),
    selectOptions() {
      return this.activeItem.options.filter(option => option.type === 'select');
    },
  },
  components: {
    dropsLoader,
    guid,
    tooltip,
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
    'input-errors',
  ],
  data() {
    return {
      hasErrors: false,
      loading: false,
      display: {
        hasOptionLimit: false,
      },
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
    inputErrors(list) {
      this.hasErrors = list.find(item => item.key === this.type);
    },
  },
  methods: {
    setInitialValues() {
      const item = this.activeItem;
      const value = typeof item[this.type] !== 'undefined' ? item[this.type] : '';
      this.$set(this.display, this.type, value);
      this.display.hasOptionLimit = item.hasOptionLimit;
    },
    updateLimit(e, item) {
      const val = this._getNumberVal({ val: e.target.value.replace(/\D/g, '') });
      this.$store.dispatch('setDropletVal', {
        drp: item,
        key: 'limit',
        val,
      });
    },
    async checkLimits() {
      this.loading = true;
      try {
        const item = await this._SEND([{
          name: 'getDynamicItem',
          payload: {
            siteId: this.currentSite._id,
            type: this.activeSiteType,
            dynamicId: this.activeItem._id,
          },
        }]);
        if (this.exists(item[this.type])) {
          this.$store.dispatch('setDropletVal', {
            drp: this.activeItem,
            key: this.type,
            val: item[this.type],
          });
          this.display[this.type] = item[this.type];
        }
        if (this.exists(this.activeItem.options) && this.exists(item.options)) {
          this.$store.dispatch('setDropletVal', {
            drp: this.activeItem,
            key: 'options',
            val: item.options,
          });
        }
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'error',
          message,
        });
      } finally {
        this.loading = false;
      }
    },
    exists(value) {
      return typeof value !== 'undefined';
    },
    handleErrors() {
      if (this.value.required) {
        const value = this.display[this.type] || '';
        const input = !_.isNumber(value) ? value.replace(/\s/g, '') : value.toString();
        const hasError = this.value.required && input === '' && !this.display.hasOptionLimit;
        this.$emit('set-input-error', { key: this.type, hasError, tab: this.dynamicTab });
        this.hasErrors = hasError;
      } else {
        this.hasErrors = false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/custom-limits/index.js